/* eslint-disable max-len */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import { Box } from '@mui/system';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ContainerPainel from 'components/container_painel';
import { ListDropdown } from 'api/common.types';
import {
  DEFAULT_PAGINATION_QUERY,
  INSTITUTION_FILTER_STORAGE,
} from 'api/common.const';
import { SelectChangeEvent } from '@mui/material';
import InputMask from 'react-input-mask';
import { CircularProgress } from '@mui/material';
import check from 'assets/icons/check_circle.svg';
import WifiIcon from 'assets/icons/wifiicon.svg';
import { CicaafAPI } from 'api/cicaaf/cicaaf.api';
import { validateCNPJ } from '../../../../services/utils/cnpj.utils';
import { validarCPF } from 'utils/uteis';
import { GetAllInstitutionQuery } from 'api/institutions/dtos/get-all-institution.query.dto';
import { ROUTES } from 'routes/constants';

const Cicaaf: React.FC = () => {
  const navigate = useNavigate();
  const [erroDialogState, setErroDialogState] = useState({
    open: false,
    title: '',
    message: '',
  });

  const loadFiltersFromLocalStorage = () => {
    const storagedFilters = localStorage.getItem(INSTITUTION_FILTER_STORAGE);
    return storagedFilters
      ? JSON.parse(storagedFilters)
      : DEFAULT_PAGINATION_QUERY;
  };

  const [filters, setFilters] = useState<Partial<GetAllInstitutionQuery>>(
    () => {
      const saved = loadFiltersFromLocalStorage();
      return { ...saved, sortBy: saved.sortBy || 'created_at' };
    },
  );
  const [cnpjCpf, setCnpjCpf] = useState('');
  const [showCnpjCpfField, setShowCnpjCpfField] = useState(false);
  const [showCollectionInfo, setShowCollectionInfo] = useState(false);
  const [activeCollectionInfo, setActiveCollectionInfo] = useState<{
    uuid: string;
    year: number;
    date: string;
  } | null>(null);
  const [selectedEstablishmentType, setSelectedEstablishmentType] =
    useState<string>('');
  const [establishmentName, setEstablishmentName] = useState('');
  const [loading, setLoading] = useState(false);
  const [profilesDropdown, setProfilesDropdown] = useState<ListDropdown[]>([]);
  const [apiOnline, setApiOnline] = useState<boolean | null>(null);

  const MaskedInput = InputMask as unknown as React.FC<any>;

  const handleEstablishmentTypeChange = (e: SelectChangeEvent<string>) => {
    const value = e.target.value;
    setSelectedEstablishmentType(value);
    setCnpjCpf('');

    if (value === 'COOPERATIVA' || value === 'ASSOCIAÇÃO') {
      setShowCnpjCpfField(true);
    } else if (value === 'AGROINDÚSTRIA') {
      setShowCnpjCpfField(true);
    } else {
      setShowCnpjCpfField(false);
    }
  };
  const handleStartCollection = async () => {
    setLoading(true);
    const rawCnpjCpf = cnpjCpf.replace(/\D/g, '');

    setTimeout(() => {
      setShowCollectionInfo(true);
    }, 2000);

    if (!selectedEstablishmentType) {
      setErroDialogState({
        open: true,
        title: 'Tipo de Estabelecimento Obrigatório',
        message:
          'Você deve selecionar o tipo de estabelecimento antes de continuar.',
      });
      setLoading(false);
      return;
    }

    if (selectedEstablishmentType === 'AGROINDÚSTRIA') {
      if (!rawCnpjCpf) {
        setErroDialogState({
          open: true,
          title: 'Identificação Obrigatória',
          message: 'Preencha o CPF ou CNPJ da entidade.',
        });
        setLoading(false);
        return;
      }

      if (rawCnpjCpf.length === 11) {
        if (!validarCPF(rawCnpjCpf)) {
          setErroDialogState({
            open: true,
            title: 'CPF Inválido',
            message: 'O CPF informado é inválido. Corrija antes de continuar.',
          });
          setLoading(false);
          return;
        }
      } else if (rawCnpjCpf.length === 14) {
        if (!validateCNPJ(rawCnpjCpf)) {
          setErroDialogState({
            open: true,
            title: 'CNPJ Inválido',
            message: 'O CNPJ informado é inválido. Corrija antes de continuar.',
          });
          setLoading(false);
          return;
        }
      } else {
        if (rawCnpjCpf.length < 11) {
          setErroDialogState({
            open: true,
            title: 'CPF Incompleto',
            message: 'O campo está incompleto. Preencha todos os 11 dígitos do CPF.',
          });
        } else if (rawCnpjCpf.length < 14) {
          setErroDialogState({
            open: true,
            title: 'CNPJ Incompleto',
            message: 'O campo está incompleto. Preencha todos os 14 dígitos do CNPJ.',
          });
        } else {
          setErroDialogState({
            open: true,
            title: 'Documento Inválido',
            message: 'O documento deve ter 11 dígitos (CPF) ou 14 dígitos (CNPJ).',
          });
        }
        setLoading(false);
        return;
      }
    } else {
      if (showCnpjCpfField && !rawCnpjCpf) {
        setErroDialogState({
          open: true,
          title: 'Identificação Obrigatória',
          message: 'Preencha o CNPJ ou CPF da entidade.',
        });
        setLoading(false);
        return;
      }

      // Validação de CNPJ
      if (
        (selectedEstablishmentType === 'COOPERATIVA' ||
          selectedEstablishmentType === 'ASSOCIAÇÃO') &&
        !validateCNPJ(rawCnpjCpf)
      ) {
        setErroDialogState({
          open: true,
          title: 'CNPJ Inválido',
          message: 'O CNPJ informado é inválido. Corrija antes de continuar.',
        });
        setLoading(false);
        return;
      }
    }

    try {
      const identificationToUse = rawCnpjCpf;

      // 1. Verifica existência de coleta
      const existingRes = await CicaafAPI.checkExisting(identificationToUse);
      const existing = existingRes.dados;

      // 2. Se houver coleta ativa, mostra botão de continuar
      if (existing?.has_active_collection && existing?.active_collection_uuid) {
        setActiveCollectionInfo({
          uuid: existing.active_collection_uuid,
          year: new Date().getFullYear(),
          date: new Date().toLocaleDateString('pt-BR'),
        });
        setTimeout(() => setLoading(false), 2000);
        return;
      }

      // 3. Se houver coleta anterior → copiar
      if (
        existing?.has_previous_collections &&
        existing.previousCollectionUuid
      ) {
        try {
          const copiedRes = await CicaafAPI.copyFromPrevious(
            existing.previousCollectionUuid,
          );
          const reused = copiedRes.dados;

          if (!reused?.uuid) {
            throw new Error('Erro ao copiar dados da coleta anterior.');
          }

          navigate(ROUTES.DADOS_GERAIS_CICAAF.replace(':uuid', reused.uuid));
          setTimeout(() => setLoading(false), 2000);
          return;
        } catch (copyError: any) {
          setErroDialogState({
            open: true,
            title: 'Erro ao reaproveitar coleta',
            message:
              copyError?.message ||
              'Não foi possível iniciar a nova coleta com base na anterior.',
          });
          setTimeout(() => setLoading(false), 2000);
          return;

        }
      }

      // 4. Cria nova coleta
      const createRes = await CicaafAPI.createManualCollection({
        identification: identificationToUse,
        entity_type: selectedEstablishmentType,
        entity_name: establishmentName,
      });

      const created = createRes?.dados;

      if (!created?.uuid) {
        throw new Error('Erro ao criar nova coleta. Tente novamente.');
      }

      navigate(ROUTES.DADOS_GERAIS_CICAAF.replace(':uuid', created.uuid));
      setTimeout(() => setLoading(false), 2000);
    } catch (error: any) {
      setErroDialogState({
        open: true,
        title: 'Erro ao Iniciar Coleta',
        message:
          error?.message ||
          error?.Mensagem ||
          'Erro inesperado ao iniciar coleta. Por favor, tente novamente.',
      });
      setTimeout(() => setLoading(false), 2000);
    }
  };

  useEffect(() => {
    const savedFilters = loadFiltersFromLocalStorage();
    if (savedFilters) {
      setFilters(savedFilters);
    }

    const mockProfiles: ListDropdown[] = [
      { name: 'Cooperativa', uuid: 'COOPERATIVA' },
      { name: 'Agroindústria', uuid: 'AGROINDÚSTRIA' },
      { name: 'Associação', uuid: 'ASSOCIAÇÃO' },
    ];
    setProfilesDropdown(mockProfiles);
  }, []);

  useEffect(() => {
    const checkApiStatus = async () => {
      try {
        await CicaafAPI.checkHealth();
        setApiOnline(true);
      } catch (error) {
        setApiOnline(false);
      }
    };

    checkApiStatus();

    const interval = setInterval(checkApiStatus, 100000);

    return () => clearInterval(interval);
  }, []);

  return (
    <ContainerPainel pagina='Nova Coleta de Entidades' showBackButton={true}>
      <Box
        sx={{
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'center',
          backgroundColor: '#FFFFFF',
          padding: '20px',
        }}
      >
        <Typography
          variant='body2'
          sx={{
            color: '#fff',
            backgroundColor: '#212121',
            padding: '4px 10px',
            borderRadius: '20px',
            display: 'flex',
            alignItems: 'center',
            marginRight: '650px',
            fontSize: '12px',
            fontWeight: 'bold',
          }}
        >
          <img
            src={WifiIcon}
            alt='wifi'
            style={{ width: 16, height: 16, marginRight: '6px' }}
          />
          {apiOnline ? 'Online' : 'Offline'}
        </Typography>

        <Box
          sx={{
            backgroundColor: '#FFFFFF',
            padding: '0px',
            borderRadius: '8px',
            boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
            width: '100%',
            maxWidth: '740px',
            textAlign: 'center',
            position: 'relative',
            marginTop: '20px',
          }}
        >
          <Box
            sx={{
              backgroundColor: '#0048b6',
              padding: '30px',
              borderRadius: '8px 8px 0 0',
              width: '100%',
              marginBottom: '20px',
            }}
          >
            <Typography
              variant='h5'
              sx={{
                color: '#FFFFFF',
                fontWeight: '500',
                fontFamily: 'revert',
                textAlign: 'left',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <img
                src={check}
                alt='check icon'
                style={{ width: '28px', height: 'auto', marginRight: '8px' }}
              />
              Identificação do Estabelecimento
            </Typography>
            <Typography
              variant='body1'
              sx={{ color: '#FFFFFF', fontSize: '14px', textAlign: 'left' }}
            >
              Informe os dados para iniciar a coleta
            </Typography>
          </Box>

          <Box sx={{ marginTop: '20px', padding: '0 20px' }}>
            <FormControl
              fullWidth
              variant='outlined'
              sx={{ marginTop: '20px' }}
            >
              <InputLabel htmlFor='establishment-type' shrink>
                Tipo de Estabelecimento *
              </InputLabel>

              <Select
                id='establishment-type'
                value={selectedEstablishmentType || ''}
                onChange={handleEstablishmentTypeChange}
                label='Tipo de Estabelecimento'
                displayEmpty
                sx={{
                  textAlign: 'left',
                  borderRadius: '8px',
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#B0BEC5',
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#0048b6',
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#0048b6',
                  },
                }}
              >
                <MenuItem value=''>
                  Selecione o tipo de estabelecimento
                </MenuItem>
                {profilesDropdown.map((profile) => (
                  <MenuItem key={profile.uuid} value={profile.uuid}>
                    {profile.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Dialog
              open={erroDialogState.open}
              onClose={() =>
                setErroDialogState({ ...erroDialogState, open: false })
              }
            >
              <DialogTitle>{erroDialogState.title}</DialogTitle>
              <DialogContent>
                <p>{erroDialogState.message}</p>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() =>
                    setErroDialogState({ ...erroDialogState, open: false })
                  }
                >
                  Fechar
                </Button>
              </DialogActions>
            </Dialog>

            {showCnpjCpfField && selectedEstablishmentType === 'AGROINDÚSTRIA' && (
              <FormControl
                fullWidth
                variant='outlined'
                sx={{ marginTop: '20px' }}
              >
                <InputLabel htmlFor='cpf-cnpj' shrink={cnpjCpf !== ''}>
                  CPF ou CNPJ da Entidade *
                </InputLabel>
                {(() => {
                  const raw = cnpjCpf.replace(/\D/g, '');
                  const isCpf = raw.length === 11;
                  const isCnpj = raw.length === 14;
                  const isCpfValid = isCpf && validarCPF(raw);
                  const isCnpjValid = isCnpj && validateCNPJ(raw);
                  const hasError = (isCpf && !isCpfValid) || (isCnpj && !isCnpjValid);
                  const helperText = isCpf && !isCpfValid
                    ? 'CPF inválido'
                    : isCnpj && !isCnpjValid
                      ? 'CNPJ inválido'
                      : '';

                  let displayValue = '';
                  if (raw.length <= 11) {
                    displayValue = raw.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
                  } else {
                    displayValue = raw.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
                  }

                  return (
                    <TextField
                      id='cpf-cnpj'
                      label='CPF ou CNPJ da Entidade *'
                      variant='outlined'
                      fullWidth
                      value={displayValue}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        const newValue = e.target.value.replace(/\D/g, '');
                        if (newValue.length <= 14) {
                          setCnpjCpf(newValue);
                        }
                      }}
                      inputProps={{
                        maxLength: 18,
                      }}
                      error={hasError}
                      helperText={helperText}
                    />
                  );
                })()}
                <FormHelperText
                  sx={{ color: '#666', marginBottom: '8px', textAlign: 'left' }}
                >
                  Será verificado na Base de Dados
                </FormHelperText>
              </FormControl>
            )}

            {showCnpjCpfField && selectedEstablishmentType !== 'AGROINDÚSTRIA' && (
              <FormControl
                fullWidth
                variant='outlined'
                sx={{ marginTop: '20px' }}
              >
                <InputLabel htmlFor='cnpj-cpf' shrink={cnpjCpf !== ''}>
                  CNPJ da Entidade *
                </InputLabel>
                <MaskedInput
                  mask='99.999.999/9999-99'
                  value={cnpjCpf}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setCnpjCpf(e.target.value)
                  }
                >
                  {(inputProps: any) => (
                    <TextField
                      {...inputProps}
                      id='cnpj-cpf'
                      label='CNPJ da Entidade *'
                      variant='outlined'
                      fullWidth
                      required
                    />
                  )}
                </MaskedInput>

                <FormHelperText
                  sx={{ color: '#666', marginBottom: '8px', textAlign: 'left' }}
                >
                  Será verificado na Base de Dados
                </FormHelperText>
              </FormControl>
            )}

            {showCnpjCpfField && (
              <TextField
                label='Nome da entidade'
                value={establishmentName}
                onChange={(e) => setEstablishmentName(e.target.value.toLocaleUpperCase())}
                required
                fullWidth
                sx={{ marginTop: '20px' }}
              />
            )}

            <Button
              variant='contained'
              fullWidth
              sx={{
                backgroundColor: '#0048b6',
                color: '#FFFFFF',
                fontSize: '16px',
                padding: '12px',
                '&:hover': {
                  backgroundColor: '#005ce6ff',
                },
                marginTop: '40px',
                marginBottom: '20px',
              }}
              onClick={handleStartCollection}
            >
              {loading ? (
                <CircularProgress size={24} sx={{ color: '#fff' }} />
              ) : (
                'Verificar e Iniciar Coleta'
              )}
            </Button>

            {showCollectionInfo && activeCollectionInfo && (
              <Box
                sx={{
                  backgroundColor: '#FFF8DC',
                  border: '1px solid #FFECB3',
                  borderRadius: '8px',
                  padding: '16px',
                  marginBottom: '10px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  gap: '6px',
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <Typography sx={{ fontWeight: 'bold', color: '#8B4513' }}>
                    <span
                      style={{ display: 'inline-flex', alignItems: 'center' }}
                    >
                      <span
                        role='img'
                        aria-label='info'
                        style={{ marginRight: '4px' }}
                      >
                        ⚠️
                      </span>
                      Coleta encontrada para este estabelecimento
                    </span>
                  </Typography>
                </Box>

                <Typography variant='body2'>
                  <strong>Status:</strong>{' '}
                  <span
                    style={{
                      backgroundColor: '#212121',
                      color: '#fff',
                      borderRadius: '6px',
                      padding: '2px 8px',
                      fontSize: '12px',
                      fontWeight: 'bold',
                    }}
                  >
                    Em coleta
                  </span>
                </Typography>

                <Typography variant='body2'>
                  <strong>Ano:</strong> {activeCollectionInfo.year}
                </Typography>
                <Typography variant='body2'>
                  <strong>Data:</strong> {activeCollectionInfo.date}
                </Typography>

                <Button
                  variant='contained'
                  sx={{
                    marginTop: '10px',
                    backgroundColor: '#1E88E5',
                    color: '#fff',
                    textTransform: 'none',
                    fontWeight: 'bold',
                    borderRadius: '6px',
                    padding: '6px 16px',
                    '&:hover': {
                      backgroundColor: '#1565C0',
                    },
                  }}
                  onClick={() => {
                    if (!activeCollectionInfo?.uuid) return;

                    localStorage.setItem(
                      'cicaaf_form_data',
                      JSON.stringify({
                        cnpjCpf,
                        establishmentName,
                        selectedEstablishmentType,
                      }),
                    );

                    navigate(
                      ROUTES.DADOS_GERAIS_CICAAF.replace(
                        ':uuid',
                        activeCollectionInfo.uuid,
                      ),
                    );
                  }}
                >
                  Continuar Coleta
                </Button>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </ContainerPainel>
  );
};

export default Cicaaf;
